import { all, put, takeEvery, call, select } from "redux-saga/effects";
import { ACCESS_VOUCHERS_ACTIONS, ACCESS_VOUCHERS_TYPES } from "./actions";
import {
  getAccessVoucherTemplate as APIgetAccessVoucherTemplate,
  getAccessVoucherTemplates as APIgetAccessVoucherTemplates,
  createAccessVoucherTemplate as APIcreateAccessVoucherTemplate,
  updateAccessVoucherTemplate as APIupdateAccessVoucherTemplate,
  deleteAccessVoucherTemplate as APIdeleteAccessVoucherTemplate
} from "../../services/api/accessVoucherTemplates";
import { navigateTo } from "../navigation/saga";
import { accessVouchersFilters } from "./selectors";

export function* watchAccessVouchersActions() {
  yield all([
    takeEvery(ACCESS_VOUCHERS_TYPES.LOAD_ALL_REQUEST, getAccessVouchers)
  ]);
  yield all([takeEvery(ACCESS_VOUCHERS_TYPES.LOAD_REQUEST, getAccessVoucher)]);
  yield all([
    takeEvery(ACCESS_VOUCHERS_TYPES.CREATE_REQUEST, createAccessVoucher)
  ]);
  yield all([
    takeEvery(ACCESS_VOUCHERS_TYPES.UPDATE_REQUEST, updateAccessVoucher)
  ]);
  yield all([
    takeEvery(ACCESS_VOUCHERS_TYPES.DELETE_REQUEST, deleteAccessVoucher)
  ]);
  yield all([
    takeEvery(ACCESS_VOUCHERS_TYPES.CREATE_SUCCESS, getAccessVouchers)
  ]);
  yield all([
    takeEvery(ACCESS_VOUCHERS_TYPES.DELETE_SUCCESS, getAccessVouchers)
  ]);
  yield all([
    takeEvery(ACCESS_VOUCHERS_TYPES.UPDATE_FILTERS, getAccessVouchers)
  ]);
}

function* getAccessVouchers(action) {
  try {
    const filters = yield select(accessVouchersFilters);
    const accessVouchers = yield call(APIgetAccessVoucherTemplates, filters);
    yield put(ACCESS_VOUCHERS_ACTIONS.loadAllSuccess(accessVouchers));
  } catch (e) {
    yield put(ACCESS_VOUCHERS_ACTIONS.loadAllFailure(e));
  }
}

function* getAccessVoucher(action) {
  const { id } = action.payload;
  try {
    const accessVoucher = yield call(APIgetAccessVoucherTemplate, id);
    yield put(ACCESS_VOUCHERS_ACTIONS.loadSuccess(accessVoucher));
  } catch (e) {
    yield put(ACCESS_VOUCHERS_ACTIONS.loadFailure(e));
  }
}

function* createAccessVoucher(action) {
  const { values, redirect } = action.payload;
  try {
    const accessVoucher = yield call(APIcreateAccessVoucherTemplate, values);
    yield put(ACCESS_VOUCHERS_ACTIONS.createSuccess(accessVoucher));
    if (redirect) {
      yield call(
        navigateTo,
        "/admin/events/" + values.eventId + "/vouchers/access"
      );
    } else {
      yield call(
        navigateTo,
        "/admin/events/" + values.eventId + "/vouchers/access/create"
      );
    }
  } catch (e) {
    yield put(ACCESS_VOUCHERS_ACTIONS.createFailure(e));
  }
}

function* updateAccessVoucher(action) {
  const { id, values } = action.payload;
  try {
    const accessVoucher = yield call(
      APIupdateAccessVoucherTemplate,
      id,
      values
    );
    yield put(ACCESS_VOUCHERS_ACTIONS.updateSuccess(accessVoucher));
    yield call(
      navigateTo,
      "/admin/events/" + values.eventId + "/vouchers/access"
    );
  } catch (e) {
    yield put(ACCESS_VOUCHERS_ACTIONS.updateFailure(e));
  }
}

function* deleteAccessVoucher(action) {
  const { id } = action.payload;
  try {
    const accessVoucher = yield call(APIdeleteAccessVoucherTemplate, id);
    yield put(ACCESS_VOUCHERS_ACTIONS.deleteSuccess(accessVoucher));
  } catch (e) {
    yield put(ACCESS_VOUCHERS_ACTIONS.deleteFailure(e));
  }
}
